import { createUseStyles } from "react-jss";

export default createUseStyles((theme: any) => ({
    gridItem: {
        composes: "grid__item",
        margin: 0,
        minWidth: theme.GridCellMinWidth,
        minHeight: theme.GridCellMinHeight,
        padding: theme.GridCellPadding,
    },
    gridItemError: {
        composes: "grid__item--error",
    },
    gridRowHeader: {
        composes: "grid__row-header",
        fontWeight: "normal",
        minWidth: 50,
        textAlign: "left",
    },
    gridColumnHeader: {
        composes: "grid__column-header",
        fontWeight: "normal",
        verticalAlign: "top",
    },
    gridChoiceHeader: {
        composes: "grid__choice-header",
        fontWeight: "bold",
        verticalAlign: "top",
    },
}));
